var CoreObject   = require("enyo/CoreObject"),
    EventEmitter = require("enyo/EventEmitter"),
    kind         = require("enyo/kind");

require("enyo-ui");

/**
 * A simple object, mixing `enyo.EventEmitter`.
 *
 * @class   enyo-ui.EventEmitter
 * @extends enyo.CoreObject
 * @mixes   enyo.EventEmitter
 * @public
 */
module.exports = kind(/** @lends  enyo-ui.EventEmitter.prototype */ {

    /**
     * @private
     */
    name: "enyo-ui.EventEmitter",

    /**
     * @private
     */
    kind: CoreObject,

    /**
     * @private
     */
    mixins: [EventEmitter]

});
